<template>
  <section class="ai-visibility-recommendation-list">
    <section-header
      :title="title"
      :subtitle="subtitle"
    />
    <div class="ai-visibility-recommendation-list__grid">
      <recommendation-card
        v-for="item in items"
        :key="item.id"
        :item="item"
        :site-id="siteId"
        :tracker-id="trackerId"
        :citations-action-to="citationsActionTo"
        @navigate-tab="$emit('navigate-tab', $event)"
      />
    </div>
  </section>
</template>

<script>
import SectionHeader from '../../../ui/cards/SectionHeader.vue'
import RecommendationCard from './RecommendationCard.vue'

export default {
  name: 'RecommendationList',
  components: {
    SectionHeader,
    RecommendationCard,
  },
  props: {
    title: {
      type: String,
      default: 'What we recommend you do next',
    },
    subtitle: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
    siteId: {
      type: [Number, String],
      required: true,
    },
    trackerId: {
      type: [Number, String],
      required: true,
    },
    citationsActionTo: {
      type: [Object, String],
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-recommendation-list {
  margin-top: 22px;
}

.ai-visibility-recommendation-list__grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

@media (max-width: 720px) {
  .ai-visibility-recommendation-list__grid {
    flex-direction: column;
  }
}
</style>
